export const orderInitialState = {
    allOrders: [],
  };
  
  export const orderReducer = (state, action) => {
    switch (action.type) {
      case "FETCH_ALL_ORDERS":
        state.allOrders= action.payload
        return {
            allOrders:[...state.allOrders]
        };
      default:
        break;
    }
  };
  